/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, July 7th 2022, 6:18:02 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { useTranslatedText } from "core";
import { OSActionButton, EmptyStateActionWrapper, Image } from "ui-widgets";
import { StageFormButtonWrapper } from "./StageFormButtonWrapper";

export const EmptyStagesCTA = ({ onCreateNewStage }) => {
  const LANG = useTranslatedText();

  return (
    <div style={{ padding: 20 }}>
      <EmptyStateActionWrapper
        title={<>No stages yet for this workflow</>}
        description={LANG.stageSettingsDescription}
        illustrationGraphic={<Image className="image-style-A" src="/img/stage.png" alt="" />}
      >
        <StageFormButtonWrapper onSuccessfulAPISave={onCreateNewStage}>
          <OSActionButton variant="contained" size="large">
            Create New Stage
          </OSActionButton>
        </StageFormButtonWrapper>
      </EmptyStateActionWrapper>
    </div>
  );
};
